"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const _tagged_template_literal = require("@swc/helpers/_/_tagged_template_literal");
function _templateObject() {
    const data = _tagged_template_literal._([
        "\n  fragment ProductListingFacets on PlpFacet {\n    name\n    active\n    name\n    displayName\n    values {\n      key\n      count\n      active\n      displayName\n      facetInfo {\n        color\n      }\n    }\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.productListingFacets = void 0;
var _fetching = require("@ori/fetching");
const productListingFacets = exports.productListingFacets = (0, _fetching.gql)(_templateObject());
